import { observer } from 'mobx-react';
import React from 'react';
import { UFBNoticeClickEvent } from '@udemy/browse-event-tracking';
import { Tracker } from '@udemy/event-tracking';
import { useI18n } from '@udemy/i18n';
import { toBusinessUdemy } from '@udemy/organization';
import { MobileNavItem, MobileNavL1Nav, MobileNavSection } from '../mobile-nav.react-component';
export const MobileUdemyBusinessNav = observer(() => {
  const {
    gettext,
    locale
  } = useI18n();
  const handleClickUBHomeClick = url => {
    Tracker.publishEvent(new UFBNoticeClickEvent({
      locale,
      placement: 'mobile_nav',
      url
    }));
  };
  const handlePlansClick = url => {
    Tracker.publishEvent(new UFBNoticeClickEvent({
      locale,
      placement: 'mobile_nav',
      url
    }));
  };
  const handleDemoClick = url => {
    Tracker.publishEvent(new UFBNoticeClickEvent({
      locale,
      placement: 'mobile_nav',
      url
    }));
  };
  const homeUrl = toBusinessUdemy('', {
    ref: 'ub_header_home'
  });
  const plansUrl = toBusinessUdemy('plans', {
    ref: 'ufb_header_plans'
  });
  const demoUrl = toBusinessUdemy('request-demo-mx', {
    ref: 'ufb_header_demo'
  });
  return /*#__PURE__*/React.createElement(MobileNavL1Nav, {
    id: "header-toggle-side-nav-udemy-business-nav"
  }, /*#__PURE__*/React.createElement(MobileNavSection, null, /*#__PURE__*/React.createElement(MobileNavItem, {
    href: homeUrl,
    onClick: () => handleClickUBHomeClick(homeUrl)
  }, gettext('About Udemy Business')), /*#__PURE__*/React.createElement(MobileNavItem, {
    href: plansUrl,
    onClick: () => handlePlansClick(plansUrl)
  }, gettext('Compare Plans')), /*#__PURE__*/React.createElement(MobileNavItem, {
    href: demoUrl,
    onClick: () => handleDemoClick(demoUrl)
  }, gettext('Try Udemy Business'))));
});
//# sourceMappingURL=mobile-udemy-business-nav.react-component.js.map